import { render, staticRenderFns } from "./IndexSuppliersPage.vue?vue&type=template&id=2ad943fc&"
import script from "./IndexSuppliersPage.vue?vue&type=script&lang=js&"
export * from "./IndexSuppliersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports